/**
 * Shown when the browser blocked the meeting tab. Stays open until the tab
 * really opens or the user dismisses the dialog.
 */

import * as React from 'react';
import { BaseModal } from '@/components/common/modals/BaseModal';
import { Button } from '@/components/forms/Button';
import { AlertTriangle, ExternalLink } from 'lucide-react';
import { getErrorMessage } from '@/utils/errors-utils';

/** Props for {@link VisioPopupBlockedModal}. */
interface VisioPopupBlockedModalProps {
  open: boolean;
  onClose: () => void;
  onRetry: () => void;
  onOpenSameTab: () => void;
}

/** Shown when the browser blocked the meeting tab. */
export const VisioPopupBlockedModal: React.FC<VisioPopupBlockedModalProps> = ({
  open,
  onClose,
  onRetry,
  onOpenSameTab,
}) => (
  <BaseModal
    open={open}
    onClose={onClose}
    size="md"
    hideCloseButton={true}
    closeOnOutsideClick={false}
    closeOnEscape={false}
    header={{
      icon: AlertTriangle,
      iconColor: 'var(--color-3-nuance-1)',
      iconBgColor: 'color-mix(in srgb, var(--color-3-nuance-1) 15%, transparent)',
      iconSize: 'md',
      title: getErrorMessage('visioPopupBlockedTitle'),
      titleColor: 'var(--foreground)',
      titleSize: 'lg',
      titleWeight: 'semibold',
    }}
    description={getErrorMessage('visioPopupBlockedDetail')}
    hideContentWrapper={true}
    footer={
      <div className="flex flex-wrap gap-2 justify-end w-full">
        <Button preset="modal-cancel" onClick={onClose}>
          Fermer
        </Button>
        <Button variant="outline" size="md" icon={ExternalLink} onClick={onOpenSameTab}>
          Ouvrir dans cet onglet
        </Button>
        <Button preset="modal-confirm" onClick={onRetry}>
          Réessayer
        </Button>
      </div>
    }
  >
    <div />
  </BaseModal>
);
